import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState, useActions } from "@nosto/preact"

export default function Products() {
    const {
        response: { products },
        loading
    } = useAppState()

    const { updateSearch } = useActions();

    document.querySelector('header').classList.add('ns-page-header')
    document.querySelector('.predictive-search__header button[close-desktop-search]').click()

    if(localStorage.getItem("scrollpoint")){
        function checkScrollToItem(){
            if(document.getElementById(localStorage.getItem("scrollpoint"))){
                document.getElementById(localStorage.getItem("scrollpoint")).scrollIntoView()
                localStorage.removeItem("scrollpoint");
             }else{
              setTimeout(checkScrollToItem, 100);
            }
          }
          checkScrollToItem();       
    }

    if(localStorage.getItem("lazyloadedNum")){
        updateSearch({
            products: {
                size: localStorage.getItem("lazyloadedNum")
            },
        });

        localStorage.removeItem("lazyloadedNum");
    }

    return (
        <ul class="collection-grid__grid grid grid-cols-2 desktop:grid-cols-4 gap-x-[1px] gap-y-[48px]" style={loading ? "opacity: 0.3;" : ""}>
            {products.hits.map((hit, index) => {
                console.log('Search Product', hit)
                return <Product product={hit} key={hit.productId || index} />
            })}
        </ul>
    )
}
